import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Backdrop,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useTranslation } from "react-i18next";

const UnauthorizedPopup = ({ open, title, description }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      BackdropComponent={Backdrop}
      sx={{ pointerEvents: "auto", padding: 5 }}
      PaperProps={{
        sx: {
          margin: { xs: 0, sm: 0, md: 4 },
        },
      }}
    >
      {title && (
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LockIcon color="error" /> {title}
        </DialogTitle>
      )}
      <DialogContent>
        {description && <Typography variant="body1">{description}</Typography>}
      </DialogContent>
    </Dialog>
  );
};

export default UnauthorizedPopup;
